import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';

import { fleetKeys } from '@/hooks/fleet-keys';
import { apiClient, fleetPath } from '@/lib/api-client';

/** POST /servers/:name/provision — launch the VPN server. */
export function useProvisionServer(): UseMutationResult<{ task_id: number }, Error, string> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (serverName) =>
      apiClient.post<{ task_id: number }>(
        fleetPath(`/servers/${encodeURIComponent(serverName)}/provision`),
        undefined,
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: fleetKeys.all });
    },
  });
}
